export const buildQueryParams = (
    raw: Record<string, string | number | boolean | undefined | null>,
): Record<string, string> => {
    return Object.entries(raw).reduce(
        (acc, [key, val]) => {
            if (val !== undefined && val !== null) {
                acc[key] = String(val);
            }
            return acc;
        },
        {} as Record<string, string>,
    );
};
